import { IMAGES } from "@/components/landing/images";

const REGIONS = [
  { name: "Greater Adelaide", detail: "North, South, East, West & CBD" },
  { name: "Hills & Fleurieu", detail: "Mount Barker, Victor Harbor, Strathalbyn" },
  { name: "Northern & Barossa", detail: "Gawler, Tanunda, Nuriootpa" },
  { name: "Regional SA", detail: "Remote & regional coordination" },
];

export default function ServiceArea() {
  return (
    <section id="service-area" className="py-20 px-5 sm:px-8 bg-[#F6F1EA] border-t border-[#EAE3D8]" data-testid="service-area-section">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <div className="space-y-6">
          <span className="text-xs uppercase tracking-widest text-[#786655] font-semibold">Coverage</span>
          <h2 className="text-3xl sm:text-4xl font-display font-medium text-[#1E282D]">Supporting participants statewide across South Australia</h2>
          <p className="text-base text-[#4E5B62] leading-relaxed">
            Whether you are based in Greater Adelaide, the Adelaide Hills, Barossa, Fleurieu Peninsula, or regional SA communities, our support workers and coordinators travel to you.
          </p>
          <div className="grid grid-cols-2 gap-4 text-sm pt-2">
            {REGIONS.map((r) => (
              <div key={r.name} className="p-4 rounded-xl bg-[#FAF8F5] border border-[#E4DCCE]">
                <div className="font-semibold text-[#1E282D]">{r.name}</div>
                <div className="text-xs text-[#5D6B72] mt-1">{r.detail}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="relative aspect-[4/3] rounded-3xl overflow-hidden border border-[#DFD5C5] shadow-sm">
          <img src={IMAGES.map} alt="South Australian landscape" loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#1E282D]/30 via-transparent to-[#1E282D]/10" />
          <div className="relative h-full flex flex-col justify-between p-6 sm:p-8">
            <div className="flex items-center justify-between">
              <span className="text-xs font-semibold uppercase tracking-wider text-[#524436] bg-[#FAF8F5]/80 px-3 py-1 rounded-full">South Australia Service Region</span>
            </div>
            <div className="space-y-2 bg-[#FAF8F5]/90 backdrop-blur-sm p-4 rounded-2xl border border-[#D9CEBF] max-w-sm">
              <div className="text-xs font-semibold text-[#1E282D]">Beneficence Care Network</div>
              <div className="text-xs text-[#4F5D64]">Active mobile teams providing home visits, community transport, and coordination throughout SA.</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
